module.exports = __webpack_public_path__ + "static/img/hJefLg3A.bb9b343.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/horse-nest/hJefLg3A.jpg
// module id = Y2jo
// module chunks = 7